import { Alert, alertClasses, styled } from "@mui/material";

const CheckboxContainer = styled("div")`
  display: flex;
  align-items: flex-start;
  column-gap: 8px;
  padding: 0px 20px 20px 20px;
`;

const Note = styled(Alert)`
  &.${alertClasses.root} {
    background-color: #f4f4f4;
    color: #333333;
    margin: 0px 20px 20px 20px;
  }
  & .${alertClasses.icon} {
    color: #333333;
  }
`;

const NameValuePairSection = styled("section")`
  display: flex;
  flex-direction: column;
  padding: 0px 20px 20px 20px;
  row-gap: 20px;
`;

export { CheckboxContainer, Note, NameValuePairSection };
